import { authFetchBinary, BASE_BACKEND_URL } from '../../../../auth'

export async function downloadOverviewCsv(query = '') {
  const params = query.replace(/^&/, '')
  const path = `${BASE_BACKEND_URL}/poc/overview/download`.replace(/([^:]\/)\/+/g, '$1')
  const url = params ? `${path}?${params}` : path

  try {
    const res = await authFetchBinary(url, { method: 'GET' })

    if (!res) return

    if (res.status === 204) {
      alert('No hay órdenes de compra para descargar en el periodo seleccionado.')
      return
    }

    if (!res.ok) {
      alert('Error al generar el archivo.')
      return
    }

    const blob = await res.blob()
    const disposition = res.headers.get('Content-Disposition') || ''
    const match = disposition.match(/filename="([^"]+)"/i)
    const fileName = match ? match[1] : 'Ordenes_de_compra.csv'

    const blobUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = blobUrl
    link.download = fileName
    link.click()
    window.URL.revokeObjectURL(blobUrl)
  } catch (err) {
    console.error('Error al descargar CSV:', err)
    alert('Error al descargar el archivo.')
  }
}
